<template>
  <CContainer>
    <CDataTable
      :fields="fields"
      :items="documents"
      hover
      :items-per-page="itemsPerPage"
      :items-per-page-select="{label:'Documentos por página', values: [10, 20, 50]}"
      pagination>
      <template #Documento="{item}">
        <td align="right">{{ item.Documento }}</td>
      </template>
      <template #Fecha_Emision="{item}">
        <td align="right">{{ item.Fecha_Emision }}</td>                     
      </template>
      <template #Valor_Total="{item}">
        <td align="right">{{ formatter.format(item.Valor_Total, 0) }}</td>
      </template>
      <template #options="{item}">
        <td>
          <a href="#"
            class="m-2"
            @click="toggleDocument(item)">
            <i class="bi bi-journal-text text-info h4"></i>
          </a>
          <a href="#" 
            class="mb-2"
            v-c-tooltip="'Descarga PDF'"
            @click="event => {
              event.stopPropagation()
              downloadElectronicDocument(item.Id_Documento, 'PDF')
            }">
            <i class="bi bi-file-earmark-pdf text-danger h4"></i>
          </a>
        </td>
      </template>
      <template #details="{item}">
        <CCollapse :show="item._toggled">
          <CDataTable
            :fields="detailFields"
            :items="item.kardex"
            outlined
            :items-per-page="5"                  
            >
            <template #Salidas="{item}">
              <td align="right">{{ item.Salidas }}</td>
            </template>
            <template #Valor_Salidas="{item}">
              <td align="right">{{ formatter.format(item.Valor_Salidas, 0) }}</td>
            </template>
          </CDataTable>
        </CCollapse>
      </template>
    </CDataTable>

    <CElementCover v-show="loading"/>
  </CContainer>
</template>
<script>
  import { formatter } from '../../../../general'
  import { 
    downloadFileObject,
    dataGridVentasCliente
  } from '../../../../api'
  import { dataDocumentoMovimientosKardex } from '../../../../apiDataGrids'
  import { descargarFacturaElectronica } from '../../../../apiReports'

  const fields = [    
    { 
      key: 'Documento',
      _style:'text-align:center;'
    },
    { 
      key: 'Fecha_Emision', 
      label: 'Emisión',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Total', 
      label: 'Total',
      _style:'text-align:center;'
    },
    { 
      key: 'Nombre_Empleado', 
      label: 'Vendedor',
      _style:'text-align:center;'
    },
    {
      key: 'options',
      label: ''
    }
  ]

  const detailFields = [
    { 
      key: 'Codigo', 
      label: 'Código',
      _style:'text-align:center;'
    },
    { 
      key: 'Descripcion', 
      label: 'Descripción',
      _style:'text-align:center;'
    },
    { 
      key: 'Referencia', 
      label: 'Presentación',
      _style:'text-align:center;'
    },
    { 
      key: 'Salidas', 
      label: 'Unidades',
      _style:'text-align:center;'
    },
    { 
      key: 'Valor_Salidas', 
      label: 'Venta',
      _style:'text-align:center;'
    },
  ]

  export default {
    data() {
      return {
        loading: false,
        documents: [],
        fields,
        detailFields,
        itemsPerPage: 10,
        formatter
      }    
    },
    methods: {
      async getData(){
        try {
          const {response} = await dataGridVentasCliente(
            this, 
            this.selectedDirectory.id_Directorio
          )
          
          this.documents = response.map(document => {
            const date = new Date(document.Fecha_Emision)
            document.kardex = []
            document.Fecha_Emision = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
            return document
          })
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        }

      },
      async getDocumentInfo(documentId){
        try {
          const documentData = await dataDocumentoMovimientosKardex(
            this, 
            documentId
          )
          const sItem = this.documents.find(document => documentId === document['Id_Documento'])
          sItem.kardex = documentData.response
          this.$set(sItem, 'kardex', documentData.response)
          this.$nextTick(() => { })
        } catch (error) {
          this.$store.commit('setAlert', {
                color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        }
      },
      async downloadElectronicDocument(idDocument, typeDocument) {
        try {
          this.loading = true

          const { response } = await descargarFacturaElectronica(this, idDocument, typeDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, typeDocument, contenidoArchivo)
        } catch(error) {
          this.$store.commit("setAlert", {
              color: "danger",
              message: "Ocurrio un error al descargar el archivo de facturación electrónica.",
              show: 5
            })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(item){
        const sItem = this.documents.find(document => item['Id_Documento'] === document['Id_Documento'])
        this.$set(sItem, '_toggled', !item._toggled)
        this.$nextTick(() => { })
        if (item._toggled) this.getDocumentInfo(item['Id_Documento'])
      }
    },
    computed: {
      selectedDirectory(){
        return this.$store.state.selectedDirectory
      },
    },
    async mounted(){
      await this.getData()
    }
  }
</script>
